import React, { useEffect } from 'react';
import { Header } from '../components/sales/Header';
import { Hero } from '../components/sales/Hero';
import { PainSection } from '../components/sales/PainSection';
import { SolutionSection } from '../components/sales/SolutionSection';
import { BenefitsSection } from '../components/sales/BenefitsSection';
import { HowItWorks } from '../components/sales/HowItWorks';
import { Testimonials } from '../components/sales/Testimonials';
import { FAQ } from '../components/sales/FAQ';
import { FinalCTA } from '../components/sales/FinalCTA';
import { Footer } from '../components/sales/Footer';
import { MessageCircle } from 'lucide-react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/qtRkR6UFYwHcZHUZTWVph1/Titulo.png';
const WHATSAPP_LINK = 'https://wa.me/50689925929?text=Hola%2C%20quiero%20m%C3%A1s%20informaci%C3%B3n%20sobre%20la%20certificaci%C3%B3n%20de%20GAS%20LP%20para%20mi%20establecimiento';
export function SalesPage() {
  useEffect(() => {
    document.title = 'JAZUGA Costa Rica';
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-[#f59e0b] selection:text-white relative" data-id="element-360">
      {/* Global Background Logo Watermark */}
      <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden" aria-hidden="true" data-id="element-361">
        {/* Top Right Logo */}
        <img src={LOGO_URL} alt="" className="absolute -top-20 -right-20 w-[600px] h-auto opacity-[0.04] transform rotate-12" data-id="element-362" />
        {/* Center Left Logo */}
        <img src={LOGO_URL} alt="" className="absolute top-[30%] -left-32 w-[500px] h-auto opacity-[0.03] transform -rotate-12" data-id="element-363" />
        {/* Bottom Right Logo */}
        <img src={LOGO_URL} alt="" className="absolute top-[60%] -right-24 w-[450px] h-auto opacity-[0.04] transform rotate-6" data-id="element-364" />
        {/* Bottom Left Logo */}
        <img src={LOGO_URL} alt="" className="absolute bottom-[10%] -left-20 w-[400px] h-auto opacity-[0.03] transform -rotate-6" data-id="element-365" />
      </div>

      <Header data-id="element-366" />
      <main className="relative z-10" data-id="element-367">
        <Hero data-id="element-368" />
        <PainSection data-id="element-369" />
        <SolutionSection data-id="element-370" />
        <div id="beneficios" data-id="element-371">
          <BenefitsSection data-id="element-372" />
        </div>
        <div id="proceso" data-id="element-373">
          <HowItWorks data-id="element-374" />
        </div>
        <div id="testimonios" data-id="element-375">
          <Testimonials data-id="element-376" />
        </div>
        <div id="faq" data-id="element-377">
          <FAQ data-id="element-378" />
        </div>
        <FinalCTA data-id="element-379" />
      </main>
      <Footer data-id="element-380" />

      {/* Floating WhatsApp Button */}
      <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-2xl transition-transform hover:scale-110 flex items-center justify-center" aria-label="Contactar por WhatsApp" data-id="element-381">
        <MessageCircle className="w-8 h-8 fill-current" data-id="element-382" />
      </a>
    </div>;
}